<template>
  <el-dialog
    :close-on-click-modal="false"
    :lock-scroll="true"
    :visible.sync="show"
    width="78%"
    top="30px"
    center
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div style="margin-top: 10px;margin-bottom: 10px;text-align: center;">
      <span style="font-size: 20px;">{{ user.companyTitle + '费用报销单' }}</span>
    </div>
    <div>
      <el-form style="text-align: center">
        <div style="margin-bottom: 10px;">
          <el-row>
            <el-col :span="9" left>申请部门:<span>{{ fybxd.bmmc }}</span></el-col>
            <el-col :span="3" center>日期：&nbsp;&nbsp;&nbsp;&nbsp;<span v-text="fybxd.rq"></span></el-col>
            <el-col :span="2" center> <el-icon name="arrow" size="20px"></el-icon></el-col>
            <el-col :span="4" center>单据号：<span v-text="fybxd.djh"></span></el-col>

            <el-col :span="3"><span style="float: right">单位：元</span></el-col>
          </el-row>
        </div>
        <table style="width: 98%;margin: 1px auto">
          <col style="width: 6%">
          <col style="width: 5%">
          <col style="width: 4%">
          <col style="width: 6%">
          <col style="width: 6%">
          <col style="width: 6%">
          <col style="width: 6%">
          <col style="width: 6%">
          <tr>
            <td>
              <span style="line-height: 44px">报销人</span>
            </td>
            <td colspan="3">
              <!--<span v-text="jkr"></span>-->
              <el-select v-model="fybxd.jkr" placeholder="请选择报销人" style="width: 100%">
                <el-option
                  v-for="item in optionsFyBxUser"
                  :key="item.subjectCode"
                  :label="item.subjectName"
                  :value="[item.subjectName,item.subjectCode,item.dictCode,item.dictName]">
                </el-option>
              </el-select>
            </td>
            <td><span>集团总裁</span></td>
            <td><span v-text="lcPersons[9]"></span></td>
            <td><span>集团CFO</span></td>
            <td><span v-text="lcPersons[8]"></span></td>
          </tr>
          <tr>
            <td rowspan="3"><span style="line-height: 44px">报销内容</span></td>
            <td rowspan="3" colspan="3" style="text-align: left;">
              <el-row v-if="!view">
                <el-button style="margin-left: 10px" type="primary" icon="el-icon-plus" size="mini" circle @click="addBxnr"></el-button>
                <el-button style="margin-left: 5px" icon="el-icon-minus" size="mini" circle @click="reduceBxnr"></el-button>
              </el-row>
              <el-row
                v-for="(item, index) in bxnrArr"
                :key="index"
                :name="item.bxnr"
              >
                <el-select v-model="item.bxnr" :disabled="view" style="width: 120px;margin-left: 10px" size="mini">
                  <el-option
                    v-for="fb in optionsFyBxnr"
                    :key="fb.dictCode"
                    :label="fb.dictName"
                    :value="fb.dictName">
                  </el-option>
                </el-select>
                <!--<el-input v-model="item.bxnr" placeholder="" style="width: 120px;margin-left: 10px" size="mini" :readonly="true"></el-input>-->
                <el-input v-model="item.bxje" :readonly="view" style="width: 120px;margin-left: 10px" size="mini" @change="jeChange"></el-input>
              </el-row>
            </td>
            <td><span style="line-height: 44px">总经理</span></td>
            <td><span v-text="lcPersons[7]"></span></td>
            <td><span>董事长</span></td>
            <td><span v-text="lcPersons[6]"></span></td>
          </tr>

          <tr>
            <td><span style="line-height: 44px">总会计师</span></td>
            <td><span v-text="lcPersons[5]"></span></td>
            <td><span>副总经理</span></td>
            <td><span v-text="lcPersons[4]"></span></td>
          </tr>

          <tr>
            <td><span style="line-height: 44px">财务部长</span></td>
            <td><span v-text="lcPersons[3]"></span></td>
            <td><span>部门负责人</span></td>
            <td><span v-text="lcPersons[2]"></span></td>
          </tr>
          <tr>
            <td><span style="line-height: 44px">金额(小写)</span></td>
            <td><span>{{ fybxd.jeXx }}</span></td>
            <td><span>所附票据</span></td>
            <td><el-input v-model="fybxd.sfpj" :readonly="view" placeholder="请输入所附票据"></el-input></td>
            <td><span>审核会计</span></td>
            <td><span v-text="lcPersons[1]"></span></td>
            <td><span>经办人</span></td>
            <td><span v-text="fybxd.lrr"></span></td>
          </tr>
          <tr>
            <td><span style="line-height: 44px">金额(大写)</span></td>
            <td colspan="3"><span v-text="fybxd.jeDx"></span></td>
            <td><span>备注</span></td>
            <td colspan="3"><el-input v-model="fybxd.bz" :readonly="view" placeholder="请输入备注"></el-input></td>
          </tr>
        </table>
      </el-form>
    </div>

    <el-tabs v-model="shqk" style="width: 98%;margin: auto">
      <el-tab-pane label="审核情况" name="one">
        <!-- 审核情况 -->
        <examineTemplate
          :property="examineTemplate.workflowData"
        ></examineTemplate>

      </el-tab-pane>

      <el-tab-pane label="个人借款明细" name="two" style="width: 100%">
        <div>
          <div>
            <span>借款人借款情况：</span>
          </div>
          <table style="width: 100%;margin-bottom: 5px;margin-top: 5px;padding: 3px;text-align: center">
            <col style="width: 10%">
            <col style="width: 23%">
            <col style="width: 10%">
            <col style="width: 23%">
            <col style="width: 10%">
            <col style="width: 23%">
            <tr>
              <td>累计借款</td>
              <td><span v-text="Grmxljjk"></span></td>
              <td>已还款</td>
              <td><span v-text="Grmxyjk"></span></td>
              <td>借款余额</td>
              <td><span v-text="Grmxjkye"></span></td>
            </tr>
          </table>
          <div>
            <span>个人明细：</span>
          </div>
          <table style="width: 100%;margin-bottom: 5px;margin-top: 5px;padding: 3px;text-align: center">
            <col style="width: 10%">
            <col style="width: 20%">
            <col style="width: 15%">
            <col style="width: 15%">
            <col style="width: 15%">
            <col style="width: 15%">
            <col style="width: 10%">
            <tr>
              <td>日期</td>
              <td>摘要</td>
              <td>凭证号</td>
              <td>票据号</td>
              <td>借款</td>
              <td>还款</td>
              <td>余额</td>
            </tr>
            <tr>
              <td>期初</td>
              <td>上年结转</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>0.00</td>
            </tr>
            <tr>
              <td>期末</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
      </el-tab-pane>

    </el-tabs>
    <span slot="footer">
      <el-button v-if="!view" type="primary" @click="editSaveClick">保存</el-button>
      <el-button type="danger" style="margin-left: 3%" @click="closeFybxd('0')">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PublicBuill from './js/publicBuill'
import examineTemplate from './examineTemplate'
export default {
  components: {
    examineTemplate
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    property: {
      type: Object,
      deault: {}
    },
    viewBool: Boolean
  },
  data() {
    return {
      fybxd: {},
      shqk: 'one',
      view: true,
      bxnrArr: [],
      workflowData: [],
      show: true,
      /* 编辑页面所需 */
      optionsFyBxUser: [],
      optionsFyBxnr: [],
      sh: [],
      Grmxljjk: '',
      Grmxyjk: '',
      Grmxjkye: '',
      lcPersons: ['', '', '', '', '', '', '', '', '', ''], // 流程人员
      examineTemplate: {
        workflowData: []
      }
    }
  },
  mounted() {
    this.initData(this.property)
    this.view = this.viewBool
    if (!this.view) { // view 为true 表示当前页面为只读  false 为编辑
      this.getFyBxnr()
      this.getFyBxUser()
    }

  },
  created() {
    PublicBuill.setThis(this)
  },
  methods: {
    /* 数据初始化 */
    initData(row) {
      console.log(row.djh)
      const data = {
        djh: row.djh
      }
      this.$post('/fesback/Financial/findBillByDjh.z', data).then(request => {
        console.log(request)
        if (request.success) {
          this.fybxd = request.data.data
          console.log(this.fybxd)
          this.sh = request.data.sh

          for (let i = 1; i <= 10; i++) {
            if (!this.fybxd['bxnr' + i] || this.fybxd['bxnr' + i] === '') {
              break
            }
            const temp = {
              bxnr: this.fybxd['bxnr' + i],
              bxje: this.fybxd['bxje' + i]
            }
            this.bxnrArr.push(temp)
          }
          this.fybxd.rq = this.fybxd.rq.split(' ')[0]
          this.fybxd.jeDx = PublicBuill.convertCurrency(this.fybxd.je)
          this.fybxd.jeXx = PublicBuill.formatAmount(this.fybxd.je)
        } else {
          this.$message.error(request.message)
        }
      })
    },
    /* 关闭页面 */
    closeFybxd(val) {
      this.show = false
      this.$emit('closeFybxd', val)
    },
    /* 报销内容 */
    addBxnr() {
      const temp = {
        bxnr: '',
        bxje: ''
      }
      if (this.bxnrArr.length <= 7) {
        this.bxnrArr.push(temp)
      }
    },
    reduceBxnr() {
      if (this.bxnrArr.length >= 2) {
        this.bxnrArr.pop()

        let je = 0.0
        this.bxnrArr.forEach(value => {
          if (value.bxje !== null && value.bxje !== '')
            je = (parseFloat(value.bxje) + parseFloat(je)).toFixed(2)
        })
        this.je = je
        this.jedx = PublicBuill.convertCurrency(je)
      }
    },
    /* 金额 */
    jeChange() {
      let je = 0.0
      this.bxnrArr.forEach(value => {
        if (value.bxje !== null && value.bxje !== '')
          je = (parseFloat(value.bxje) + parseFloat(je)).toFixed(2)
      })
      console.log(je)
      this.jexx = je
      this.jedx = this.convertCurrency(je)
    },
    /* 保存 */
    editSaveClick() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.config.loading = true
      const data = {
        djh: this.djh,
        jkr: this.jkr,
        jkrid: this.jkrid,
        bz: this.bz,
        sfpj: this.sfpj,
        rq: this.rq,
        je: this.jexx,
        userName: localStorage.getItem('userName'),
        userNo: localStorage.getItem('userNo'),
        bmbm: this.bmbm,
        bmmc: this.bmmc,
        flowId: this.flowId,
        lrr: localStorage.getItem('userName'),
        lrrId: localStorage.getItem('userNo'),
        lrrq: this.lrrq === '' ? new Date() : this.lrrq,
        rejected: '0'
      }
      this.bxnrArr.forEach((value, index) => {
        const bxnr = 'bxnr' + (index + 1)
        const bxje = 'bxje' + (index + 1)
        data[bxnr] = value.bxnr
        if (value.bxje === '') {
          value.bxje = '0.00'
        }
        data[bxje] = value.bxje
      })
      for (let i = this.bxnrArr.length + 1; i <= 10; i++) {
        const notbxje = 'bxje' + (i)
        data[notbxje] = 0
      }
      if (data.jkr === '') {
        this.$message('报销人不能为空')
        this.config.loading = false
        loading.close()
      } else if (this.jexx === '') {
        this.$message('金额不能为空')
        this.config.loading = false
        loading.close()
      } else {
        let url = ''
        if (this.djh === '') {
          url = '/fesback/fybxd/save.z'
        } else if (this.rejected === '0') {
          url = '/fesback/fybxd/editFybxd.z'
        } else if (this.rejected === '1') {
          url = '/fesback/fybxd/restartWorkflow.z'
        }
        this.$post(url, data).then(response => {
          loading.close()
          this.config.loading = false
          if (response.success === true) {
            this.$message({
              type: 'success',
              message: '编辑成功!'
            })

            this.bxnrArr = [
              {
                bxnr: '',
                bxje: ''
              },
              {
                bxnr: '',
                bxje: ''
              }
            ]
            this.djh = ''
            this.jkr = ''
            this.jkrid = ''
            this.bz = ''
            this.jexx = ''
            this.jedx = ''
            this.sfpj = ''
            this.show = false
          } else {
            this.$message({
              type: 'danger',
              message: '编辑失败!'
            })
          }
        })
      }
    }

  }
}
</script>

<style scoped>
  table,table tr th, table tr td {
    border:1px solid #000000;
  }
  .el-table ::v-deep .el-table__cell {
    padding: 3px 0;
  }
</style>
